import { toast } from 'react-toastify';
import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';

const scoreContest = ({
  contestId,
  contestWeekId,
}: {
  contestId: number;
  contestWeekId: number;
}) =>
  api.post(`/contests/${contestId}/score`, {
    contest_week_id: contestWeekId,
  });

export const useScoreContestMutation = () =>
  useMutation({
    mutationKey: ['contests score'],
    mutationFn: scoreContest,
    onSuccess: () => {
      toast.success('Contest scored successfully');
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
